import { useEffect } from "react";

/**
 * Lightweight per-page SEO updater. No external dependency.
 * Updates document.title and the description / canonical / OG tags on mount.
 */
export default function useSEO({ title, description, path } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | AMAR SAHRAOUI Promotion Immobilière`
      : "AMAR SAHRAOUI Promotion Immobilière — Oran, Algérie";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [name, val] = selector.replace(/[[\]"]/g, "").split("=");
        el.setAttribute(name, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }

    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);

    const url = `https://sahraoui-promotion.com${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
    setMeta('meta[property="og:url"]', "content", url);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path]);
}
